export default __webpack_public_path__ + "static/app-mock-429d1888f7bcb773295a9f0b4dcd547b.svg";